<template>
    <notification-modal     v-model:is-open="showConfirmLongRopeUlt"
                            :give-option="true"
                            @action="confirmLongRopeUlt"
    >
        <template   #title-content>
            <span>Confirm Use of Long Rope (25 ft) ULT</span>
        </template>

        <template   #button-primary-content>
            Yes
        </template>

        <div></div>
    </notification-modal>

    <div>
        <label class="block text-sm font-medium text-gray-700" for="probe_type"> Probe Type </label>
        <div class="mt-1">
            <select2 :close-on-select="true"
                     :match-alpha-numeric="true"
                     :multiple="false"
                     :options='probeInformation'
                     name="probe_type"
                     v-model:value="probeType"
                     placeholder="Select Probe"
            ></select2>
        </div>
    </div>

    <div>
        <label class="block text-sm font-medium text-gray-700" for="reference_probe"> Reference Probe </label>
        <div class="mt-1">
            <select2 :close-on-select="true"
                     :match-alpha-numeric="true"
                     :multiple="false"
                     :options='referenceProbeInformation'
                     name="reference_probe"
                     v-model:value="referenceProbe"
                     placeholder="Select Reference"
            ></select2>
        </div>
    </div>

    <div>
        <label class="block text-sm font-medium text-gray-700" for="calibration_zone"> Holding Zone </label>
        <div class="mt-1">
            <select2-group :allow-clear="true"
                           :close-on-select="true"
                           :multiple="false"
                           :options='areaZones'
                           class="p-2 m-2"
                           name="calibration_zone"
                           v-model:value="holdingZone"
                           placeholder="Pick Zone"
            ></select2-group>
        </div>
    </div>

</template>

<script>
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import Select2Group from "@/components/elements/select2-group.vue";
import Select2 from "@/components/elements/select2.vue";
import ConfirmationModal from "@/components/elements/ConfirmationModal.vue";
import NotificationModal from "@/components/elements/NotificationModal.vue";

export default {
    name: "AutoCalibrationSonishieldSetup",
    mixins: [SonicuCoreMixin, iconNamesMixin],
    components: {NotificationModal, ConfirmationModal, Select2, Select2Group},
    emits: [],
    props: {
        probeInformation: {
            type: Object,
            required: true
        },
        referenceProbeInformation: {
            type: Object,
            required: true
        },
        areaZones: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            probeType: '',
            referenceProbe: '',
            holdingZone: '',

            // Confirm the ULT Long Rope
            showConfirmLongRopeUlt: false,
            longRopeUltIsConfirmed: false,
        }
    },
    created() {

    },
    mounted() {

    },
    methods: {
        confirmLongRopeUlt(useLongRopeUlt) {
            // this.showConfirmLongRopeUlt = false
            if (useLongRopeUlt) {
                this.longRopeUltIsConfirmed = true
            }
            else {
                this.longRopeUltIsConfirmed = false
                this.probeType = null
            }
        },
    },
    computed: {},
    watch: {
        probeType() {
            // If the Long Rope (25 ft) ULT is selected then show the confirm dialog to make sure (if it has not been confirmed already)
            if (this.probeType === "35" && !this.longRopeUltIsConfirmed) {
                this.showConfirmLongRopeUlt = true;
            }
            else {
                this.showConfirmLongRopeUlt = this.longRopeUltIsConfirmed = false;
            }
        }
    },
}
</script>

<style scoped>

</style>